import styled from '@emotion/styled'
import { ReactNode } from 'react'

import { theme } from '../../constants'
import { Flex } from '../Flex'

const Root = styled(Flex)({
  gridArea: 'Footer',
  paddingLeft: theme.spacing[3],
  paddingRight: theme.spacing[3],
  paddingTop: theme.spacing[2.5],
  paddingBottom: theme.spacing[3],
  gap: theme.spacing[2],
  justifyContent: 'end',
  minHeight: 60,
  borderTop: `1px solid ${theme.color.borderLight}`,
})

export const Footer = ({ children }: { children: ReactNode }) => {
  return <Root>{children}</Root>
}
